function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-5 { fill: #00081c; }\n      .cls-2 { fill: #ffd300; }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Container"
}, React.createElement("rect", {
  className: "cls-2",
  width: 999.31,
  height: 832.76
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "AA"
}, React.createElement("path", {
  className: "cls-5",
  d: "M874.31,229.42h-121.01c-5.6,0-10.76,3.03-13.49,7.92l-202,362.48V239.71c0-5.68-4.61-10.29-10.29-10.29h-121.01c-5.6,0-10.76,3.03-13.49,7.92L116.02,734.38c-3.82,6.86,1.14,15.3,8.99,15.3h94.74c5.65,0,10.85-3.09,13.56-8.05l48.52-89.05h141.27v86.81c0,5.68,4.61,10.29,10.29,10.29h133.16c5.65,0,10.85-3.09,13.56-8.05l48.52-89.05h141.27v86.81c0,5.68,4.61,10.29,10.29,10.29h94.12c5.68,0,10.29-4.61,10.29-10.29V239.71c0-5.68-4.61-10.29-10.29-10.29Zm-451.21,317.35h-83.62l78.78-144.6c1.28-2.34,4.83-1.44,4.83,1.23v143.37Zm346.79,0h-83.62l78.78-144.6c1.28-2.34,4.83-1.44,4.83,1.23v143.37Z"
}));

var SvgTheaa = function SvgTheaa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 180,
    height: 150,
    viewBox: "0 50 999.31 832.76",
    style: {
      backgroundColor: "#ffd300"
    },
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTheaa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/theaa.9cb42fb2.svg";
export { ForwardRef as ReactComponent };